import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { ArrowLeft, BookOpen } from "lucide-react";
import { usePublicConfig } from "@/api/queries/config";
import { flirtArticles } from "@/components/flirt-tipps/articles";
import { EmptyState } from "@/components/shared/EmptyState";
import { Button } from "@/components/ui/Button";
import { Card } from "@/components/ui/Card";
import { usePageMeta } from "@/hooks/use-page-meta";

export const Route = createFileRoute("/_app/flirt-tipps/$slug")({
	component: FlirtTippDetailPage,
});

function FlirtTippDetailPage() {
	const { slug } = Route.useParams();
	const navigate = useNavigate();
	const { data: config } = usePublicConfig();

	const article = flirtArticles.find((a) => a.slug === slug);

	usePageMeta({
		title: config && article ? `${article.title} - ${config.seo.defaultTitle}` : undefined,
	});

	if (!article) {
		return (
			<EmptyState
				icon={<BookOpen size={48} />}
				title="Artikel nicht gefunden"
				description="Dieser Artikel existiert nicht."
				action={
					<Button variant="outline" onClick={() => navigate({ to: "/flirt-tipps" })}>
						Zurück zur Übersicht
					</Button>
				}
			/>
		);
	}

	return (
		<div className="max-w-3xl mx-auto space-y-6">
			<Link
				to="/flirt-tipps"
				className="inline-flex items-center text-base text-text-secondary hover:text-primary transition-colors no-underline"
			>
				<ArrowLeft size={16} className="mr-1" />
				Zurück zur Übersicht
			</Link>

			<Card padding="lg">
				<h1 className="text-2xl font-bold text-text mb-4">{article.title}</h1>
				<div className="text-text-secondary whitespace-pre-line leading-relaxed">
					{article.content}
				</div>
			</Card>
		</div>
	);
}
